import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";


const initialState = {
  data: [
      { name: 'FHA', margin: "", revenueCap: "", isRevenue: false },
      { name: 'FHA High Balance', margin: "", revenueCap: "", isRevenue: false },
      { name: 'FHA ARM', margin: "", revenueCap: "", isRevenue: false },
      { name: 'FHA Streamline', margin: "", revenueCap: "", isRevenue: false },
      { name: 'VA', margin: "", revenueCap: "", isRevenue: false },
      { name: 'VA High Balance', margin: "", revenueCap: "", isRevenue: false },
      { name: 'VA IRRL', margin: "", revenueCap: "", isRevenue: false },
      { name: 'USDA', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Conforming', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Conforming High Balance', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Conforming ARM', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Jumbo', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Jumbo ARM', margin: "", revenueCap: "", isRevenue: false },
      { name: 'Non-QM', margin: '', revenueCap: '', isRevenue: false },
  ], 
  status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
  loading: false,
  error: null,
  formErrors: {},
}

export const fetchInitialState = createAsyncThunk(
  'MarginManagement/fetch',
  async (_, { getState, rejectWithValue }) => {
    const token = getState().navigator.token;

    try {
      const response = await fetch(`${BACKEND_API_URL}/api/onboarding/margin_management?token=${token}`);
      
      if (!response.ok) {
        console.error(`Failed to fetch initial state: ${response.status} ${response.statusText}`);
        return rejectWithValue('Failed to fetch initial state');
      }

      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error('Error fetching initial state:', error);
      return rejectWithValue('An error occurred while fetching the initial state');
    }
  }
);


// Create New State
export const SubmitMarginManagement = createAsyncThunk(
    'MarginManagement/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {
        try {
          // Add userId to the data
          const {token, currentStep} = getState().navigator;

          const hasFilled = data.some(item => item.margin === undefined || item.margin === '');
          if (hasFilled) {
            return rejectWithValue('Please enter a valid margin values for all the products');
          }

          const hasIssue = data.some(item => item.isRevenue && (item.revenueCap === undefined || item.revenueCap === '' || item.revenueCap === 0));
          if (hasIssue) {
            return rejectWithValue('Please enter a valid revenue cap for the selected products');
          }

          // all margins are mandatory
          // const mandatoryMissing = data.some(item => item.margin === 0)
          // if (mandatoryMissing) {
          //   return rejectWithValue('All the margin values are required.');
          // }

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/margin_management?token=${token}`, {
            method: 'POST',
            body: JSON.stringify({ 'data': data, 'current_step': currentStep }),
            headers: {
                'Content-Type': 'application/json',
            }
        });
          const response_data =  await response.json();
          // Handle the response data
          // console.log('Form submitted successfully', response_data);
    
          // Return the response data for the fulfilled action
          // dispatch(updateUserId({ userId: response_data['id']}));
          return response_data.products;
        } catch (error) {
          // Handle submission errors
          console.error('Form submission error', error);
          // Throw an error for the rejected action
          return rejectWithValue(error.message);
        }
      }
)


// Slice

export const marginManagementSlice = createSlice({
    name: 'MarginManagement',
    initialState,
    reducers: {
      updateProducts: (state, action) => {
        const { index, type, value } = action.payload;
        const newProducts = state.data.map((product, i) => {
          if (i === index) {
            return { ...product, [type]: value };
          }
          return product;
        });
        return { ...state, data: newProducts };
      },
    },
    extraReducers: (builder) => {
        builder
          // CREATE or UPDATE
          .addCase(SubmitMarginManagement.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitMarginManagement.fulfilled, (state, action) => {
            state.loading = false;
            // Keep the current rows when the API sends no product list back
            if (Array.isArray(action.payload)) {
              state.data = action.payload;
            }
          })
          .addCase(SubmitMarginManagement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })

          // GET
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            // products comes back null when the step doesn't apply (pl === "No");
            // keep the default rows so the page doesn't crash before it skips ahead
            if (Array.isArray(action.payload?.products)) {
              state.data = action.payload.products;
            }
            state.filledBy = action.payload?.filledBy || ""
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            console.log(initialState);
            state.loading = false;
            state.error = action.payload;
          })
      },
  });


export const { updateProducts } = marginManagementSlice.actions;

export default marginManagementSlice.reducer;
  